import * as React from "react";

import "./Spinner.css";

import { connect } from "react-redux";
import { StoreState } from "../../store";

interface SpinnerProps {
  isLoading: boolean;
  isDirectSoilMeasurementAPIRequest?: boolean;
}

const mapStateToProps = (state: StoreState) => ({
  isLoading: state.loading.length > 0,
  isDirectSoilMeasurementAPIRequest: state.loading.some(req =>
    req.url.endsWith("soil/directsoilmeasurement")
  )
});

export const Spinner: React.FC<SpinnerProps> = ({
  isLoading,
  isDirectSoilMeasurementAPIRequest = false
}) => {
  if (isLoading) {
    return (
      <div className="Spinner">
        <svg className="circular" viewBox="25 25 50 50">
          <circle
            className="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="3"
            strokeMiterlimit="10"
          />
        </svg>
        {isDirectSoilMeasurementAPIRequest ? (
          <h3 className="Spinner__text">
            Sampling nearby soil percentages
            <br />
            This may take up to 30 seconds…
          </h3>
        ) : null}
      </div>
    );
  }
  return null;
};

export default connect(mapStateToProps)(Spinner);
